import { nanoid } from 'nanoid';
import { type TagLine, TagLineAlignMode, TagLinePointMode } from '@types';

export const TAGLINE_DEFAULT_TITLE_SETTING = {
  alignMode: TagLineAlignMode.middle,
  distorted: 0,
  enableRotate: 0,
  rotate: 0,
  fontSize: 14,
  fontColor: '0,0,0,1',
  bgColor: '255,255,255,1',
};
export const TAGLINE_DEFAULT_STYLE_SETTING = {
  lineWidth: 2,
  lineColor: '255,255,255,1',
  pointMode: TagLinePointMode.circle,
  pointColor: '255,255,255,1',
};
export const TAGLINE_DEFAULT: TagLine = {
  id: `tl_${nanoid()}`,
  startAth: 0,
  startAtv: 0,
  endAth: 0,
  endAtv: 0,
  title: '',
  titleSetting: {
    alignMode: TagLineAlignMode.middle,
    distorted: 1,
    enableRotate: 0,
    rotate: 0,
    fontSize: 14,
    fontColor: '0,0,0,1',
    bgColor: '255,255,255,1',
  },
  style: {
    lineWidth: 2,
    lineColor: '255,255,255,1',
    pointMode: TagLinePointMode.circle,
    pointColor: '255,255,255,1',
  },
};
